// extracted by mini-css-extract-plugin
export default {"root":"guHbcBpHnNRNO5vL0n7w","page":"Go0OL3zaoJMH8wDdsDpP"};